module.exports = __webpack_public_path__ + "img/icon1.697ac175.png";